import { z } from "zod";

import { conditionsValidatedDtoSchema } from "@/types/backoffice/dto/bonus-offer/condition-validated-dto";

export const offerDtoSchema = z.object({
  offerId: z.number(),
  offerName: z.string(),
  conditions: z.array(conditionsValidatedDtoSchema),
});

export type TOfferDto = z.infer<typeof offerDtoSchema>;
